import styled, { css } from 'styled-components'

interface ContainerProps extends React.CSSProperties {}

export const Container = styled.div<ContainerProps>`
  position: relative;
  width: 100%;
  height: max-content;
  padding: 1rem;

  flex-shrink: 0;
  border-radius: 0.5rem;
  background-color: ${({ theme }) => theme.zds.colors.neutral1000};
`

export const Title = styled.p`
  color: ${props => props.theme.colors.color545e6c};

  text-wrap: balance;
  font-family: 'Inter';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 16.8px;
`

export const PercentStatusIndicator = styled.div<{ variation: 'increased' | 'population' }>`
  width: 1rem;
  height: 1rem;
  border-radius: 100%;

  ${({ variation }) => {
    switch (variation) {
      case 'increased':
        return css`
          background-color: #ffcac2;
          border: 1px solid #b82116;
        `
      case 'population':
        return css`
          background-color: #b2ebce;
          border: 1px solid #146630;
        `
    }
  }}
`

export const PercentStatusLabel = styled.p`
  color: ${props => props.theme.colors.color545e6c};

  font-family: 'Inter';
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 15px;
`

export const ProgressBarGradient = styled.div`
  position: relative;
  width: 100%;
  height: 40px;

  border-radius: ${({ theme }) => theme.zds.border.radius100};
  background: ${props =>
    `linear-gradient(90deg, ${props.theme.colors.color1f6ecd} 0.82%, ${props.theme.colors.color122d52} 100%)`};
`

export const ProgressIndicator = styled.div<{ progress: number }>`
  position: relative;
  left: ${({ progress }) => progress}%;
  height: 100%;

  transform: translateX(-50%);
  z-index: 2;

  &::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 2px;
    height: 40px;
    transform: translate(-50%, 110%);
    background-color: ${({ theme }) => theme.zds.colors.neutral1000};
  }
`

export const Indicator = styled.div<{ color: string }>`
  position: relative;
  overflow: hidden;
  transform: translateX(20%) rotate(-30deg) skewY(30deg) scaleX(0.866);
  pointer-events: none;
  width: 1rem;
  height: 1rem;

  &::before,
  &::after {
    content: '';
    position: absolute;
    background: ${({ color }) => color};
    pointer-events: auto;

    width: 1rem;
    height: 1rem;
  }

  &::before {
    transform: scaleX(1.155) skewY(-30deg) rotate(-30deg) translateY(-42.3%) skewX(30deg) scaleY(0.866) translateX(-24%);
    border-radius: 20% 20% 20% 55%;
  }

  &::after {
    transform: scaleX(1.155) skewY(-30deg) rotate(-30deg) translateY(-42.3%) skewX(-30deg) scaleY(0.866) translateX(24%);
    border-radius: 20% 20% 55% 20%;
  }
`

export const PercentBaseIndicator = styled.div<{ percent: number }>`
  position: absolute;
  left: ${({ percent }) => percent}%;
  bottom: 0;
  transform: ${({ percent }) => `translateX(-${percent}%)`};
  background-color: ${({ theme }) => theme.zds.colors.neutral1000};
`

export const Progress = styled.p`
  color: ${props => props.theme.colors.color545e6c};
  font-family: 'Inter';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
`

export const ReferenceValue = styled.span`
  width: 100%;

  color: ${props => props.theme.colors.color5a6a7e};
  font-family: 'Inter';
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
`

export const ReferenceLink = styled.a`
  color: ${props => props.theme.colors.color122d52};
  font-family: 'Inter';
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
  text-decoration-line: underline;
`
